import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgxBaseCommonModule } from '@kimaya/ngx-base-common-hive';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [ConfirmationDialogComponent],
  exports: [ConfirmationDialogComponent],
  imports: [
    CommonModule,
    NgxBaseCommonModule,
    MatDialogModule,
    MatToolbarModule,
    MatButtonModule,
  ]
})
export class ConfirmationDialogModule {
}
